var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagPurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8724 6.52485L11.4749 3.12735C10.7624 2.41485 9.77986 2.03235 8.77486 2.08485L5.02486 2.26485C3.52486 2.33235 2.33236 3.52485 2.25736 5.01735L2.07736 8.76735C2.03236 9.77235 2.40736 10.7549 3.11986 11.4674L6.51736 14.8649C7.91236 16.2599 10.1774 16.2599 11.5799 14.8649L14.8724 11.5724C16.2749 10.1849 16.2749 7.91985 14.8724 6.52485ZM7.12486 9.28485C5.93236 9.28485 4.96486 8.31735 4.96486 7.12485C4.96486 5.93235 5.93236 4.96485 7.12486 4.96485C8.31736 4.96485 9.28486 5.93235 9.28486 7.12485C9.28486 8.31735 8.31736 9.28485 7.12486 9.28485Z",
    fill: "#A84198"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagPurple);
export default __webpack_public_path__ + "static/media/tag-purple.2b28a77353b5dc66cbb10e463a0637dc.svg";
export { ForwardRef as ReactComponent };